import { HomeFooter } from "homepage/homeFooter";
import { Header } from "homepage/homeHeader";
import React, { useEffect, useState } from "react";
import api from "services/api";

export const AboutUs = () => {
  const [fetchDetails, setFetchDetails] = useState("");

  const fetchData = async () => {
    try {
      const response = await api.get("/site-settings");
      const details = response?.data?.data?.siteSettings;
      setFetchDetails(details);
      console.log("fetchAboutus:", details);
    } catch (error) {
      console.log("fetchAboutus:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <>
      {/* <div className="home-page"> */}
      <Header />
      <section className="network text-center" >
        <div className="container network-block">
          <div className="row">
            <div className="col-md-12 mt-5 mb-5">
              <div className="network-content" style={{minHeight: "200px"}}>
                <h3 className="text-center mb-1">
                  <span className="position-relative fw-bold z-1">
                    About Us
                    <img
                      src="../../assets/img/front-pages/icons/section-title-icon.png"
                      alt="laptop charging"
                      className="section-title-img position-absolute object-fit-contain bottom-0 z-n1"
                    />
                  </span>
                  <br />
                </h3>
                <p
                  className="title-slogan px-5 mt-5"
                  dangerouslySetInnerHTML={{ __html: fetchDetails?.about_us }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <HomeFooter />
      {/* </div> */}
    </>
  );
};
